import React from "react";
import PropTypes from "prop-types";

import ResetPasswordForm from "../Account/ResetPasswordForm";
import LoginForm from "../Account/LoginForm";

const ResetPassword = (props) => {
    return (
        <div className="container">
            <div className="row">
                <div className="col-6 m-auto">
                    <h1 className="title">{props.title}</h1>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    {props.errorMsg && (
                        <div className="alert alert-danger" role="alert">
                            {props.errorMsg}
                        </div>
                    )}
                    {props.successMsg && (
                        <div className="alert alert-success" role="alert">
                            {props.successMsg}
                        </div>
                    )}
                </div>
                <div className="col-md-6 m-auto">
                    <div className="card">
                        {props.successMsg
                            ? (
                                <div className="card-body">
                                    <h2 className="title">Password changed</h2>
                                    <p>
                                        You can now log in with your new password.
                                    </p>
                                    <LoginForm />
                                </div>
                            ) : (
                                <div className="card-body">
                                    <h2 className="title">Password Recovery</h2>
                                    <p>
                                        Please enter a new password for your
                                        account. After submitting you will be able
                                        to login with your new password.
                                    </p>
                                    <ResetPasswordForm
                                        defaults={{
                                            id: props.id,
                                            token: props.token,
                                        }}
                                    />
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

ResetPassword.propTypes = {
    title: PropTypes.string,
    id: PropTypes.string,
    token: PropTypes.string,
    errorMsg: PropTypes.string,
    successMsg: PropTypes.string,
};

export default ResetPassword;
